var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 1.875H15.625V0.625C15.625 0.279375 15.3456 0 15 0C14.6544 0 14.375 0.279375 14.375 0.625V1.875H10.625V0.625C10.625 0.279375 10.345 0 10 0C9.655 0 9.375 0.279375 9.375 0.625V1.875H5.625V0.625C5.625 0.279375 5.345 0 5 0C4.655 0 4.375 0.279375 4.375 0.625V1.875H1.66688C0.74625 1.875 0 2.62063 0 3.54125V18.3331C0 19.2537 0.74625 20 1.66688 20H18.3337C19.2544 20 20 19.2537 20 18.3331V3.54125C20 2.62063 19.2544 1.875 18.3337 1.875ZM18.75 18.3331C18.75 18.5631 18.5631 18.75 18.3337 18.75H1.66688C1.43687 18.75 1.25 18.5631 1.25 18.3331V3.54125C1.25 3.31187 1.43687 3.125 1.66688 3.125H4.375V4.375C4.375 4.72062 4.655 5 5 5C5.345 5 5.625 4.72062 5.625 4.375V3.125H9.375V4.375C9.375 4.72062 9.655 5 10 5C10.345 5 10.625 4.72062 10.625 4.375V3.125H14.375V4.375C14.375 4.72062 14.6544 5 15 5C15.3456 5 15.625 4.72062 15.625 4.375V3.125H18.3337C18.5631 3.125 18.75 3.31187 18.75 3.54125V18.3331Z",
    fill: "#7A297F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 7.5H4.375V9.375H6.875V7.5Z",
    fill: "#7A297F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10.625H4.375V12.5H6.875V10.625Z",
    fill: "#7A297F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 13.75H4.375V15.625H6.875V13.75Z",
    fill: "#7A297F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.75H8.75V15.625H11.25V13.75Z",
    fill: "#7A297F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.625H8.75V12.5H11.25V10.625Z",
    fill: "#7A297F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5H8.75V9.375H11.25V7.5Z",
    fill: "#7A297F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.75H13.125V15.625H15.625V13.75Z",
    fill: "#7A297F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 10.625H13.125V12.5H15.625V10.625Z",
    fill: "#7A297F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 7.5H13.125V9.375H15.625V7.5Z",
    fill: "#7A297F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.182094c65d937e30567fbff3ba00e6d5.svg";
export { ForwardRef as ReactComponent };